<template>
  <div class="addreserve">
    <div class="header">
      <div>
        <span>预订单号：{{orderNum}}</span>
        <img src="../../../assets/imgs/I.png" v-if="statusImg == 'I'" width="32px" height="48px" class="reservesign"
          alt="">
        <img src="../../../assets/imgs/R.png" v-if="statusImg == 'R'" width="32px" height="48px" class="reservesign"
          alt="预订">
        <img src="../../../assets/imgs/X.png" v-if="statusImg == 'X'" width="32px" height="48px" class="reservesign"
          alt="取消">
      </div>
      <div class="FunctionalityBtn">
        <el-button class="feffBtn" :loading='loading' @click="reserveClick(1)" v-if="!orderNum">保存</el-button>
        <el-button class="blueBtn" @click="goback" :loading='loading'>退出</el-button>
        <el-button class="feffBtn" style="width:120px" @click="djClick" :loading='loading' v-if="orderNum">转登记
        </el-button>
        <el-button class="blueBtn" style="width:120px" @click="reserveClick(2)" v-if="orderNum" :loading='loading'>修改预订
        </el-button>
        <el-button class="blueBtn" style="width:120px" v-if="statusImg!=='X' && orderNum " @click="qxyd"
          :loading='loading'>
          取消预订</el-button>
        <el-button class="blueBtn" style="width:120px" v-if="orderNum && statusImg=='X'" @click="hfyd"
          :loading='loading'>恢复预订
        </el-button>
        <el-button class="blueBtn" v-if="orderNum" @click="openLogDialog" :loading='loading'>日志</el-button>
      </div>
    </div>
    <div class="content">
      <div class="leftMain">

        <div class="mainTOP">
          <div class="titleName">主要信息</div>
          <el-form ref="dataForm" :model="dataForm" label-width="100px" size="mini" class="dataForm" :rules="rules">
            <el-row>

              <el-col :span="12">
                <el-form-item label="预订名称：" prop="bookName">
                  <el-input v-model="dataForm.bookName" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="到达日期：" prop="bookArriveTime">
                  <el-date-picker v-model="dataForm.bookArriveTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                    style="width:100%" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="使用时段：" prop="mealDiffer.id">
                  <el-select v-model="dataForm.mealDiffer.id" style="width:100%" placeholder="请选择">
                    <el-option v-for="item in TopTimeList" :key="item.description"
                      :label="`${item.description}  (${item.timeSection}) `" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="折扣模式：">
                  <el-select v-model="dataForm.discountModelId" style="width:100%" placeholder="请选择" clearable
                    @change="bookUpdate">
                    <el-option v-for="item in discountModelList" :key="item.value" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="餐厅：" prop="discountModelId">
                  <el-select v-model="dataForm.discountModelId" style="width:100%" placeholder="请选择"
                    @click="SalerDialogMessage">
                    <el-option v-for="item in discountModelList" :key="item.value" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="总人数：" prop="peopleNum">
                  <el-input v-model="dataForm.peopleCount" type="number" placeholder="请输入内容">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="桌数：">
                  <el-input v-model="dataForm.bookTableCount" type="number" placeholder="请输入桌数">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="桌号：" prop="ChongFoodNum">
                  <el-input v-model="dataForm.ChongFoodNum" @focus="tableNumMessage" placeholder="请输入内容">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="市场：">
                  <el-select v-model="dataForm.marketName" placeholder="请选择" style="width:100%">
                    <el-option v-for="item in marketList" :key="item.value" :label="item.description"
                      @change="marketChange" :value="item.description">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="来源：">
                  <el-select v-model="dataForm.customerSourceName" placeholder="请选择" style="width:100%">
                    <el-option v-for="item in laiyuanList" :key="item.value" :label="item.description"
                      @change="laiyuanChange" :value="item.description">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="类别：">
                  <el-select v-model="dataForm.customerTypeName" style="width:100%" placeholder="请选择">
                    <el-option v-for="item in classBie" :key="item.value" :label="item.description" @change="classBieChange"
                      :value="item.description">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="餐标：">
                  <el-input v-model="dataForm.mealLabel" style="width:80%" placeholder="请输入内容">
                  </el-input>
                  <span style="margin-left:20px">/ 桌</span>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客人姓名：">
                  <el-input v-model="dataForm.custName" style="width:100%" placeholder="请输入内容">
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="会员卡号：">
                  <el-input v-model="guestValue.marketName" style="width:100%" placeholder="请输入内容">
                  </el-input>


                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="客人单位：">
                  <el-input v-model="dataForm.corpName" style="width:100%" placeholder="请输入内容">
                  </el-input>

                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="AR账号：">
                  <el-input v-model="guestValue.marketName" style="width:100%" placeholder="请输入内容">
                  </el-input>
                </el-form-item>
              </el-col> -->


            </el-row>
          </el-form>
        </div>
        <div class="mainBottom">

          <div class="titleName">联系信息</div>
          <el-form ref="dataForm" :model="dataForm" label-width="100px" size="mini" class="dataForm" :rules="rules">
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人：" prop="contactName">
                  <el-input v-model="dataForm.contactName" style="width:100%" placeholder="请输入内容"></el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：" prop="contactTele">
                  <el-input v-model="dataForm.contactTele" style="width:60%" placeholder="请输入内容"></el-input>
                  <span style="margin-left:20px">
                    <el-checkbox v-model="dataForm.isSendMsg">发送短信</el-checkbox>
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱：">
                  <el-input v-model="dataForm.contactEmail" style="width:100%" placeholder="请输入内容"></el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="传真：">
                  <el-input v-model="dataForm.contactFax" style="width:100%" placeholder="请输入内容"></el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12 " v-if="dataForm.waiter">
                <el-form-item label="服务员：">
                  <el-input v-model="dataForm.waiter.description" @focus="waiterDialogOpen" style="width:100%"
                    placeholder="请输入内容">
                  </el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12 " v-if="!dataForm.waiter">
                <el-form-item label="服务员：">
                  <el-input v-model="dataForm.waiter" @focus="waiterDialogOpen" style="width:100%" placeholder="请输入内容">
                  </el-input>

                </el-form-item>
              </el-col>

              <el-col :span="12" v-if="dataForm.salesPerson">
                <el-form-item label="销售员：" prop="salesPerson">
                  <el-input v-model="dataForm.salesPerson.description" @focus="GetsalesPersonList" style="width:100%"
                    placeholder="请输入内容"></el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!dataForm.salesPerson">
                <el-form-item label="销售员：" prop="salesPerson">
                  <el-input v-model="dataForm.salesPerson" @focus="GetsalesPersonList" style="width:100%"
                    placeholder="请输入内容"></el-input>


                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="特殊要求：">
                  <el-input v-model="dataForm.specialRequirement" type="textarea" style="width:100%;" rows='5'
                    placeholder="请输入内容">
                  </el-input>

                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  <el-input v-model="dataForm.remark" type="textarea" style="width:100%;" rows='5' placeholder="请输入内容">
                  </el-input>

                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- <div class="rodege45" v-if="qxStatus">
          已取消预订
        </div> -->
      </div>
      <div class="rightMain">
        <div class="rightTop" ref="rightTop">
          <div class="selectmenu">
            <div class="selectTitle">
              <div>菜品</div>
              <div class="feffBtn" @click="ydOrder" v-if="orderNum">预订菜单</div>
            </div>

            <el-table :data="tableData" style="width: 100%" :max-height="orderHeight" size="mini" show-summary
              :summary-method="getSummaries">
              <el-table-column type="index" width="50" label="序号">
              </el-table-column>
              <el-table-column prop="dishesCode" label="编码">
              </el-table-column>
              <el-table-column prop="dishesName" show-overflow-tooltip label="菜名">
              </el-table-column>
              <el-table-column prop="price" align="right" label="价格">
                <template slot-scope="scope">
                  <div style="text-align:right">{{scope.row.price.toFixed(2) }} </div>
                </template>
              </el-table-column>
              <el-table-column prop="tax" align="right" label="税">
                <template slot-scope="scope">
                  <div style="text-align:right">{{scope.row.tax.toFixed(2) }} </div>
                </template>
              </el-table-column>
              <el-table-column prop="serverPrice" align="right" label="服务费">
                <template slot-scope="scope">
                  <div style="text-align:right">{{scope.row.serverPrice.toFixed(2) }} </div>
                </template>
              </el-table-column>
              <el-table-column prop="discount" align="right" label="折扣">
                <template slot-scope="scope">
                  <div style="text-align:right">{{scope.row.discount.toFixed(2) }} </div>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" align="right" label="数量">
              </el-table-column>
              <el-table-column prop="totalPrice" align="right" label="小计">
                <template slot-scope="scope">
                  <div style="text-align:right">{{scope.row.totalPrice.toFixed(2) }} </div>
                </template>
              </el-table-column>

            </el-table>

          </div>
        </div>
        <div class="rightBottom" ref="rightBottom">
          <div class="selectTitle">
            <div>预付款
            </div>
            <el-checkbox-group v-model="checkList" @change="changeRadio" v-if="orderNum">
              <el-checkbox label="Y">有效</el-checkbox>
              <el-checkbox label="refund">退款</el-checkbox>
              <el-checkbox label="SETTLED">结账</el-checkbox>
            </el-checkbox-group>
            <div class="rightSSSS" v-if="orderNum">
              <el-button class="blueBtn" @click="invoicing" :loading='loading'>预付</el-button>
              <el-button class="blueBtn" :loading='loading' @click="bookRefund">退款</el-button>
              <el-button class="blueBtn" style="width:120px" :loading='loading' @click="print">打印</el-button>
            </div>
          </div>
          <div>
            <el-table :data="payList" size="mini" :header-cell-style="{color:'#666'}" :max-height="moneyHeight"
              :summary-method="getSummarie" show-summary style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="productCode" label="付款码">
              </el-table-column>
              <el-table-column prop="productName" label="付款项目">
              </el-table-column>
              <el-table-column prop="businessDate" label="营业日期"></el-table-column>

              <el-table-column prop="totalPrice" label="金额"></el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  {{scope.row.status == 'SETTLED' ? '结账' :scope.row.status == 'NEED_SETTLED' ? '未结账 ' :   scope.row.status == 'INVALID' ? '无效账' : '无' }}
                </template>

              </el-table-column>
              <el-table-column prop="payOrRefund" label="标记">
                <template slot-scope="scope">
                  {{scope.row.payOrRefund == 'pay' ? '支付' : scope.row.payOrRefund == 'refund' ? '退款 ' : '无' }}
                </template>
              </el-table-column>

              <el-table-column prop="empName" label="操作员"></el-table-column>
              <el-table-column prop="createDate" show-overflow-tooltip label="付款时间"></el-table-column>

            </el-table>
            <!-- <div class="totalPrice">
              <div>合计</div>
              <div>1000000</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="dialogClass">
      <el-dialog title="请选择营业点" :visible.sync="SalerDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div class="returnTitle">请选择营业点</div>
            <div class="returnItem">
              <div v-for="(v, i) in cantList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''"
                @click="checkChongFoodCurrent(v,i)">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 80px;
        " class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="SalerDialog = false">取 消</el-button>
            <el-button style="" type="primary" @click="SalerDialogClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog title="请选择桌号" :visible.sync="tableNumdialog" width="970px" center>
        <div>
          <div class="changeselect">
            <div class="returnItem">
              <div v-for="(v, i) in cantList" :key="i" :class=" v.check==true ? 'returnItemCurrent' : ''"
                @click="checkChongFoodCurrent(v,i)">
                {{ v.description }}
              </div>
            </div>
            <div style="display:flex;align-items: center;justify-content: space-between;margin-bottom:20px">
              <div style="font-size:14px;line-height:36px; font-weight: 600;">
                日期

              </div>
              <el-date-picker v-model="dataForm.bookArriveTime" @change="tableNumMessage"
                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:40%" placeholder="选择日期">
              </el-date-picker>
              <div style="font-size:14px;line-height:36px; font-weight: 600;">
                时间
              </div>
              <el-select v-model="dataForm.mealDiffer.id" style="width:40%" placeholder="请选择" @change="tableNumMessage">
                <el-option v-for="item in TopTimeList" :key="item.description"
                  :label="`${item.description}  (${item.timeSection}) `" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div style="display:flex;align-items: center;">
              <div style="font-size:14px;margin-right:10px; font-weight: 600;">选择桌号:</div>
              <el-checkbox-group v-model="checkList" size="medium" @change="changecheck">
                <el-checkbox label="V">空闲</el-checkbox>
                <el-checkbox label="R">预订</el-checkbox>

              </el-checkbox-group>
            </div>
            <el-input style="
              width: 100%;
              height:50px;
              line-height:50px;
              background: #eee;
              margin-top:10px;
              margin-bottom:10px;
              font-size: 24px;
            " v-model="changechannelinput" placeholder="输入桌号快速查询" @input="tableNumMessage"></el-input>
            <div class="returnTitle">选择桌号</div>
            <div class="Item">
              <div v-for="(v, i) in tableNumList" :key="i" :class="tableNumCurrent == i ? 'ItemCurrent' : 'Items'"
                @click="checktableNumCurrent(v,i)">
                <div>
                  {{ v.outletsName }}{{v.code}}

                </div>

                <div>

                  ({{ v.statusCode == 'D' ? '脏台' : v.statusCode == 'G' ? '送单' :v.statusCode == 'V' ? '空闲' :v.statusCode == 'R' ? '预订' :v.statusCode == 'U' ? '开台' :v.statusCode == 'OO' ? '维修' :v.statusCode == 'L' ? '点菜' :'空闲' }})

                </div>


              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 80px;
        " class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="tableNumdialog = false">取 消</el-button>
            <el-button style="" type="primary" @click="checktableSure ">确 定</el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog title="查询客人档案" :visible.sync="guestDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input style="
              width: 100%;
              background: #eee;
              font-size: 24px;
              margin-top: 28px;
            " v-model="guestinput" placeholder="输入名字或拼音首字母查找客人档案"></el-input>
            <div class="guestMain">
              <el-table :data="guesttableData" v-if="guesttableData.length" height="250"
                @current-change="handleCurrentChange" highlight-current-row style="width: 100%">
                <el-table-column prop="numCode" label="档案号"> </el-table-column>
                <el-table-column prop="name" label="姓名"> </el-table-column>
                <el-table-column prop="custmerType" label="类别"> </el-table-column>
                <el-table-column prop="idCardNum" label="证件号"> </el-table-column>
                <el-table-column prop="nationality" label="国籍"> </el-table-column>
                <el-table-column prop="address" label="城市"> </el-table-column>
                <el-table-column prop="mobile" label="手机"> </el-table-column>
                <!-- <el-table-column prop="address" label="等级"> </el-table-column> -->
                <el-table-column prop="resType" label="餐饮模式">
                </el-table-column>
              </el-table>
              <el-table :data="guesttableData1" v-if="guesttableData1.length" height="250"
                @current-change="handleCurrentChange1" highlight-current-row style="width: 100%">
                <el-table-column prop="numCode" label="档案号"> </el-table-column>
                <el-table-column prop="name" label="姓名"> </el-table-column>
                <el-table-column prop="custmerType" label="类别"> </el-table-column>
                <el-table-column prop="idCardNum" label="证件号"> </el-table-column>
                <el-table-column prop="nationality" label="国籍"> </el-table-column>
                <el-table-column prop="address" label="城市"> </el-table-column>
                <el-table-column prop="mobile" label="手机"> </el-table-column>
                <!-- <el-table-column prop="address" label="等级"> </el-table-column> -->
                <el-table-column prop="resType" label="餐饮模式">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="guestDialog = false">取 消</el-button>
            <el-button style="" type="primary" @click="guestDialogClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="服务员" :visible.sync="waiterDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input style="
              width: 100%;
              background: #eee;
              font-size: 24px;
              margin-top: 28px;
            " v-model="waiterinput" placeholder="输入名字或拼音首字母查找服务员"></el-input>
            <div class="returnTitle">选择服务员</div>
            <div class="returnItem">
              <div v-for="(v, i) in waiterList" :key="i" :class="waiterCurrent == i ? 'returnItemCurrent' : ''"
                @click="checkwaiterCurrent(v,i)">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 80px;
        " class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="waiterDialog = false">取 消</el-button>
            <el-button style="" type="primary" @click="waiterDialogClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="销售员" :visible.sync="sellDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input style="
              width: 100%;
              background: #eee;
              font-size: 24px;
              margin-top: 28px;
            " v-model="changechannelinput" placeholder="输入名字或拼音首字母查找销售员"></el-input>
            <div class="returnTitle">选择销售员</div>
            <div class="returnItem">
              <div v-for="(v, i) in sellList" :key="i" :class="sellListCurrent == i ? 'returnItemCurrent' : ''"
                @click="checksellCurrent(v,i)">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 80px;
        " class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="sellDialog = false">取 消</el-button>
            <el-button style="" @click="sellDialogClick" type="primary">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <div v-if="payDialog" class="jiezhang">

        <el-dialog title="预订付款" :visible.sync="payDialog" width="960px" center :before-close="beforeClose">

          <div class="addFoodTTT">
            单号：{{ orderNum }} &nbsp; &nbsp;&nbsp; <span>桌号：{{ ChongFoodNum }} </span> &nbsp;&nbsp;&nbsp;
            应付金额：{{ this.dataForm.orderAllPrice }}
          </div>

          <el-table :data="paytableData" height="180" style="width: 100%">
            <el-table-column prop="productCode" label="付款码"> </el-table-column>
            <el-table-column prop="productName" label="描述"> </el-table-column>
            <el-table-column prop="accounname" show-overflow-tooltip label="账号"> </el-table-column>
            <el-table-column prop="transactionId" show-overflow-tooltip label="流水单号"> </el-table-column>
            <el-table-column prop="totalPrice" label="金额"> </el-table-column>
            <el-table-column prop="remark" label="备注"> </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <!-- v-show='scope.row.transactionId' -->
                <el-button v-if="!scope.row.transactionId"
                  @click.native.prevent="deleteRow(scope.$index, paytableData, scope.row)" type="text" size="small">
                  移除

                </el-button>
                <span v-else>
                  支付成功
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="paytableunder">
            <div class="underLeft">
              <el-input v-model="bzinput1" style="
              background: #eee;
              width: 400px;
              height: 65px;
              border-radius: 6px;
              margin: 16px 10px 10px 0;
            " placeholder="请输入备注"></el-input>

              <el-input v-model="lsinput2" style="
              background: #eee;
              width: 400px;
              height: 65px;
              border-radius: 6px;
            " placeholder="请输入流水单号" autofocus="autofocus" ref="gain"></el-input>
            </div>
            <div class="underMiddle">
              <div>金额</div>
              <div>
                <el-input style="font-size:24px;width:90%" v-model="jzmoney" @focus="getInputFocus($event)">
                </el-input>
              </div>
            </div>
            <div class="Collection" @click="takeMoney">收款</div>
          </div>

          <div class="payMethods">
            <div class="methodItem" v-for="(v, i) in methodItem" :key="i" @click="methodClick(v, i)">
              <!-- <img :src="imgBaseurl + v.icon_path" width="40px" height="40px" style="margin-bottom: 5px" alt="" /> -->

              <el-image :src="imgBaseurl + v.icon_path" lazy fit="cover" style="height:40px%;width:40px">
                <div slot="error" class="image-slot">
                  <img src="../../../assets/imgs/zhuanfangzhang.png" width="40px" height="40px" alt="" />
                </div>
              </el-image>
              <span> {{ v.name }} </span>
            </div>
          </div>
        </el-dialog>
      </div>
      <el-dialog title="查询日志" :visible.sync="logDialog" width="1000px" center>
        <div>
          <div class="changeReason">
            <div class="guestMain">
              <el-table :data="discountList" height="250" style="width: 100%">
                <el-table-column prop="productValue" label="订单号"> </el-table-column>
                <el-table-column prop="product" label="修改"> </el-table-column>
                <el-table-column prop="updateProduct" label="修改项"> </el-table-column>
                <el-table-column prop="oldValue" label="旧值/key"> </el-table-column>
                <el-table-column prop="newValue" label="新值/value"></el-table-column>
                <el-table-column prop="createDate" label="修改时间"> </el-table-column>
                <el-table-column prop="createName" label="操作员"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="logDialog = false">取 消</el-button>
            <el-button style="" type="primary" @click="logDialog = false">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="预付单" :visible.sync="printFlag" width="550px" center @close='closeprintFlag'>

        <div class="printSelect" v-if="checkPrinter == 1">

          <div class="printNameTxt">当前打印机：</div>
          <el-select v-model="printName" placeholder="请选择" class="PDateName" @change="changePDate">
            <el-option v-for="item in PDate" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>

        </div>

        <div style="width:100%; display:flex; justify-content: center;overflow-y: auto;height:700px ">

          <billprint :orderObj="printobj" ref="billa"> </billprint>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="printFlag = false">返 回</el-button>
          <el-button style="" type="primary" :loading="loading" @click="printtable">打 印</el-button>

        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import billprint from "@/views/components/billprint.vue"
  import getLodop from '@/utils/Lodopfuncs'
  import DateUtils from "@/utils/DateUtils";


  export default {
    components: {
      billprint,

    },
    data() {
      return {
        loading: false,
        tableData: [],
        YDID: '',
        orderNum: '',
        statusImg: '',
        sellDialog: false,
        salesPersonObj: {},
        sellList: [],
        sellListCurrent: -1,
        waiterDialog: false,
        waiterinput: '',
        waiterList: [],
        waiterCurrent: -1,
        waiterObj: {},
        guestDialog: false,
        guestinput: '',
        guesttableData: [],
        guesttableData1: [],
        guestValue: {},
        CompanyValue: {},
        changechannelinput: '',
        tableNumList: [],
        JSvalue: '',
        tableNumCurrent: 0,
        options: [],
        funcBtnShow: false,
        saleFoodList: [],
        ChongFoodCurrent: 0,
        cantList: [],
        SalerDialog: false,
        tableNumdialog: false,
        input: '桌',
        classBie: [],
        laiyuanList: [],
        marketList: [],
        qxStatus: 0,
        checkList: ['Y'],
        TopTimeList: [
          /* { name: '早', time: '(5:00-11:00)', code: '1' },
          { name: '中', time: '(11:01-16:00)', code: '2' },
          { name: '晚', time: '(16:01-23:59)', code: '3' },
          { name: '夜', time: '(00:00-04:59)', code: '4' }, */
        ],
        discountModelList: [],
        ChongFoodValue: [],
        ChongFoodName: '',
        ChongFoodNum: '',

        dataForm: {
          id: null,
          isSendMsg: true,
          bookName: null,
          contactName: null,
          contactTele: null,
          bookArriveTime: null,
          mealDiffer: {
            id: null
          },
          mealTableId: null,
          peopleCount: null,
          bookTableCount: null,
          mealLabel: null,
          customerType: null,
          marketCode: null,
          customerSource: null,
          customer: null,
          corp: null,
          discountModelId: null,
          specialRequirement: null,
          waiter: null,
          salesPerson: null,
          contactEmail: null,
          contactFax: null,
          requirement: null,
          remark: null,
          marketName: null,
          customerSourceName: null,
          customerTypeName: null,
          discountModelName: null,
          outletsId: null,
          peopleNum: null,
        },
        rules: {
          bookName: [{
            required: true,
            message: '请输入预订名称',
            trigger: 'blur'
          }],
          contactName: [{
            required: true,
            message: '请输入联系人姓名',
            trigger: 'blur'
          }],
          contactTele: [{
              required: true,
              message: '请输入电话',
              trigger: 'blur'
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '手机号码格式不正确',
              trigger: 'blur'
            }
          ],
          discountModelId: [{
            required: true,
            message: '请选择餐厅时段',
            trigger: 'blur'
          }],
          peopleNum: [{
            required: true,
            message: '请选择人数',
          }],
          salesPerson:[{
            required: true,
            message: '请选择销售员',
          }],
          ChongFoodNum: [{
            required: true,
            message: '请选择桌号',
          }],
          'mealDiffer.id': [{
            required: true,
            message: '请选择使用时段',
            trigger: 'change'
          }],
          bookArriveTime: [{
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change'
          }],
        },
        payDialog: false,
        paytableData: [],
        bzinput1: null,
        lsinput2: null,
        jzmoney: 0,
        methodItem: [],
        imgBaseurl: 'http://pmsoss.rooibook.com/',
        flagss: false,
        methodItem: [],
        alltotalPrice: 0,
        payList: [],
        logDialog: false,
        discountList: [],
        multipleSelection: [],
        printobj: {},
        printName: null,
        PDate: [],
        printFlag: false,
        checkPrinter: null,
        orderHeight: 200,
        moneyHeight: 200,
        checkList: [],
        printPosCode: ''
      }
    },
    watch: {},
    created() {
      this.getDictDataList()
      this.getLYDataList()
      this.getSCDataList()
      this.getByPosCode()
      this.discountModel()
      this.getOutletsIdList()
      // console.log(this.$route.query);
      // this.dataForm = Object.assign({},this.dataForm,this.$route.query)
      let ydorder = this.$route.query
      this.getData(ydorder)
      this.printPosCodes()

    },
    methods: {
      getData(ydorder) {
        console.log(11211, ydorder);
        if (ydorder.id) {
          let url = this.api.orderDishesList2 + '?orderRecordId=' + ydorder.id
          let methods = 'get'
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });


          this.$axios({
            url,
            methods
          }).then(res => {
            loading.close()
            if (!res.data.status || res.data.data == undefined) {
              this.dataForm = res.data.data


              this.orderNum = res.data.data.orderNum
              this.statusImg = res.data.data.status
              this.ChongFoodName = res.data.data.restaurant
              this.dataForm.ChongFoodNum = res.data.data.outletsName + res.data.data.mealTableNum
              this.ChongFoodNum = res.data.data.outletsName + res.data.data.mealTableNum
              if (res.data.data.customer) {
                this.guestValue.name = res.data.data.customer.name
              }
              if (res.data.data.corp) {
                this.CompanyValue.name = res.data.data.corp.name
              }
              if (res.data.data.salesPerson) {
                this.salesPersonObj.description = res.data.data.salesPerson.description
              }
              if (res.data.data.waiter) {
                this.waiterObj.description = res.data.data.waiter.description
              }
              if (res.data.data.orderMenusMap) {
                this.tableData = res.data.data.orderMenusMap
              }
              this.YDID = res.data.data.id
              console.log(2222, this.YDID);
              this.getMoneyList()

              let height = this.$refs.rightTop.offsetHeight;
              this.orderHeight = height - 40
            } else if (ydorder.mealID) {

              this.dataForm.bookArriveTime = ydorder.bookArriveTime + ' 00:00:00'
              this.ChongFoodName = ydorder.ChongFoodName
              this.ChongFoodNum = ydorder.ChongFoodName + ydorder.ChongFoodNum
              this.dataForm.ChongFoodNum = ydorder.ChongFoodName + ydorder.ChongFoodNum
              this.dataForm.mealDiffer.description = ydorder.mealDiffer
              this.dataForm.mealDiffer.id = ydorder.mealID
              this.dataForm.mealTableId = ydorder.mealTableId

            }
          }).catch(() => {
            loading.close()

          })

        } else if (ydorder.mealTableId) {
          this.dataForm.bookArriveTime = ydorder.bookArriveTime + ' 00:00:00'
          this.ChongFoodName = ydorder.ChongFoodName
          this.ChongFoodNum = ydorder.ChongFoodName + ydorder.ChongFoodNum
          this.dataForm.ChongFoodNum = ydorder.ChongFoodName + ydorder.ChongFoodNum
          this.dataForm.mealDiffer.description = ydorder.mealDiffer
          this.dataForm.mealDiffer.id = ydorder.mealID
          this.dataForm.mealTableId = ydorder.mealTableId
        }
      },
      goback() {
        this.$router.push({
          path: '/reserve'
        })
      },
      qxyd() {

        let methods = 'put'
        let url = this.api.bookCancel
        this.loading = true

        let data = {
          id: this.YDID
        }
        this.$axios({
          methods,
          url,
          data
        }).then(res => {
          // console.log(res);
          this.loading = false

          if (!res.data.status) {
            this.$message({
              message: "取消成功",
              type: 'success'
            });
            this.qxStatus = 1
            this.statusImg = 'X'
          } else {
            this.$notify.eror({
              title: res.data.message
            });
          }
        }).catch(() => {
          this.loading = false

        })
      },
      djClick() {
        let methods = 'put'
        let url = this.api.bookRegister
        this.loading = true
        let data = {
          id: this.YDID
        }
        this.$axios({
          methods,
          url,
          data
        }).then(res => {
          // console.log(res);
          this.loading = false

          if (!res.data.status) {
            this.$message({
              message: "登记成功",
              type: "success"
            })
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            })
          }
        }).catch(() => {
          this.loading = false

        })
      },
      hfyd() {
        let methods = 'put'
        let url = this.api.bookRecovery
        this.loading = true

        let data = {
          id: this.YDID
        }
        this.$axios({
          methods,
          url,
          data
        }).then(res => {
          // console.log(res);
          this.loading = false

          if (!res.data.status) {
            this.$message({
              message: "恢复成功",
              type: "success"
            })
            this.statusImg = 'R'
            this.qxStatus = 0
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            })
          }
        }).catch(() => {
          this.loading = false

        })
      },
      // 用餐时间 餐别
      getByPosCode() {
        let methods = 'get'
        let url = this.api.getByList
        // let data = {
        //   posCode: localStorage.getItem('posCode')
        // }
        this.$axios({
          methods,
          url
        }).then(res => {

          console.log(1232134, res.data.data);
          this.TopTimeList = res.data.data

        })
      },
      // 折扣
      discountModel() {
        let methods = 'get'
        let url = this.api.discountModel
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.discountModelList = res.data.data
          // this.dataForm.discountModelId = res.data.data[0].id
          // this.dataForm.discountModelName = res.data.data[0].name
        })
      },
      // 类别
      getDictDataList() {

        let methods = 'get'
        let url = this.api.getDictDataList + '?dictTypeCode=PosMenuType' 
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.classBie = res.data.data
          this.dataForm.customerTypeName = res.data.data[0].description
          this.dataForm.customerType = res.data.data[0].code
        })

      },
      classBieChange(val){
        this.dataForm.customerTypeName = val.description
        this.dataForm.customerType = val.code
      
      },
      // 来源
      getLYDataList() {

        let methods = 'get'
        let url = this.api.getDictDataList + '?dictTypeCode=PosCustomerSource'
        this.$axios({
          methods,
          url
        }).then(res => {
          // console.log(res);
          this.laiyuanList = res.data.data
          this.dataForm.customerSourceName = res.data.data[0].description
          this.dataForm.customerSource = res.data.data[0].code
        })

      },
      laiyuanChange(val) {
        this.dataForm.customerSourceName = val.description
        this.dataForm.customerSource = val.code
      },
      // 市场
      getSCDataList() {

        let methods = 'get'
        let url = this.api.getDictDataList + '?dictTypeCode=PosMarket'
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.marketList = res.data.data
          this.dataForm.marketName = res.data.data[0].description
          this.dataForm.marketCode = res.data.data[0].code
        })

      },
      marketChange(val) {
        this.dataForm.marketName = val.description
        this.dataForm.marketCode = val.code
      
    },
    GetCustList(ctype) {
      this.guesttableData = []
      this.guesttableData1 = []
      this.guestDialog = true
      let methods = 'get'
      let url = this.api.posGetCustList + '?queryLike=' + this.guestinput + '&ctype=' + ctype
      //客人姓名
      if (ctype == 'A') {
        this.$axios({
          methods,
          url
        }).then(res => {
          this.guesttableData = res.data.data
        })
      } else {
        //客人单位
        this.$axios({
          methods,
          url
        }).then(res => {

          this.guesttableData1 = res.data.data
        })
      }


    },
    checkwaiterCurrent(v, i) {
      this.waiterCurrent = i
      this.waiterObj = v

    },
    waiterDialogClick() {
      console.log(this.waiterObj);
      console.log(this.dataForm);


      this.dataForm.waiter = {
        id: this.waiterObj.id,
        description: this.waiterObj.description,
      }

      this.waiterDialog = false
    },
    waiterDialogOpen() {
      this.waiterDialog = true
      let methods = 'get'
      let url = this.api.waiterlistByParam + '?isOut=false&deleted=0'
      this.$axios({
        methods,
        url
      }).then(res => {
        console.log(res);
        this.waiterList = res.data.data
      })
    },
    sellDialogClick() {
      this.sellDialog = false

      this.dataForm.salesPerson = {
        id: this.salesPersonObj.id,
        description: this.salesPersonObj.description
      }
      this.waiterDialog = false
    },
    checksellCurrent(v, i) {
      this.sellListCurrent = i
      this.salesPersonObj = v
    },
    GetsalesPersonList() {
      this.sellDialog = true
      let methods = 'get'
      let url = this.api.listByParam + '?isOut=false&deleted=0'
      this.$axios({
        methods,
        url
      }).then(res => {
        this.sellList = res.data.data
      })
    },

    handleCurrentChange(v) {
      console.log(v);
      this.guestValue = v
    },
    handleCurrentChange1(v) {
      this.CompanyValue = v

    },
    guestDialogClick() {
      this.guesttableData = []
      this.guesttableData1 = []
      this.guestDialog = false

      this.dataForm.customer = {
        id: this.guestValue.id
      }
      this.dataForm.corp = {
        id: this.CompanyValue.id
      }
    },

    reserveClick(status) {
      console.log(this.dataForm);
      if (status == 1) {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {

            this.$refs.dataForm.clearValidate()

            let url = this.api.addbook
            let methods = 'post'
            let data = this.dataForm
            this.loading = true
            this.$axios({
              url,
              methods,
              data
            }).then(res => {
              if (!res.data.status) {
                this.loading = false
                this.$message({
                  message: "预订成功",
                  type: "success",

                })

                this.dataForm = res.data.data

                this.orderNum = res.data.data.orderNum
                this.statusImg = res.data.data.status
                this.ChongFoodName = res.data.data.restaurant
                this.dataForm.ChongFoodNum = res.data.data.restaurant + res.data.data.mealTableNum
                this.ChongFoodNum = res.data.data.restaurant + res.data.data.mealTableNum
                if (res.data.data.customer) {
                  this.guestValue.name = res.data.data.customer.name
                }
                if (res.data.data.corp) {
                  this.CompanyValue.name = res.data.data.corp.name
                }
                if (res.data.data.salesPerson) {
                  this.salesPersonObj.description = res.data.data.salesPerson.description
                }
                if (res.data.data.waiter) {
                  this.waiterObj.description = res.data.data.waiter.description
                }
                if (res.data.data.orderMenusMap) {
                  this.tableData = res.data.data.orderMenusMap
                }
                this.YDID = res.data.data.id
              } else {
                this.$notify.error({
                  title: res.data.message
                });
              }
            }).catch(() => {
              this.loading = false

            })
          }
        })
      } else {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            this.dataForm.id = this.YDID
            let url = this.api.editBookOrder
            let methods = 'put'
            let data = this.dataForm
            this.loading = true
            this.$refs.dataForm.clearValidate()

            this.$axios({
              url,
              methods,
              data
            }).then(res => {
              this.loading = false
              if (!res.data.status) {
                this.$message({
                  message: "修改成功",
                  type: "success",

                })
                this.orderNum = res.data.data.orderNum
                this.statusImg = res.data.data.status
                this.ChongFoodName = res.data.data.restaurant
                this.dataForm.ChongFoodNum = res.data.data.restaurant + res.data.data.mealTableNum
                this.ChongFoodNum = res.data.data.restaurant + res.data.data.mealTableNum
                if (res.data.data.customer) {
                  this.guestValue.name = res.data.data.customer.name
                }
                if (res.data.data.corp) {
                  this.CompanyValue.name = res.data.data.corp.name
                }
                if (res.data.data.salesPerson) {
                  this.salesPersonObj.description = res.data.data.salesPerson.description
                }
                if (res.data.data.waiter) {
                  this.waiterObj.description = res.data.data.waiter.description
                }
                if (res.data.data.orderMenusMap) {
                  this.tableData = res.data.data.orderMenusMap
                }
                this.YDID = res.data.data.id
              } else {
                this.$notify.error({
                  title: res.data.message
                });
              }
            }).catch(() => {
              this.loading = false

            })

          }
        })
      }

    },
    getOutletsIdList() {
      let methods = 'get'
      let url = this.api.getoutlets + '?posCode=' + localStorage.getItem('posCode')
      this.$axios({
        methods,
        url
      }).then(res => {
        console.log(res);
        this.cantList = []
        this.ChongFoodName = res.data.data[0].description
        this.ChongFoodValue[0] = res.data.data[0].id
        res.data.data.forEach((v, i) => {
          this.$set(v, 'check', true)
          this.cantList.push(v)
        });
      })

    },
    SalerDialogMessage() {
      this.getOutletsIdList()
      this.SalerDialog = true

    },
    changecheck() {
      this.tableNumMessage()
    },
    // 选择餐桌
    tableNumMessage() {

      this.tableNumdialog = true
      let url = this.api.posBookMealTableList
      let methods = 'get'
      let arr = []
      this.cantList.forEach(res => {
        if (res.check == true) {
          arr.push(res.id)
        }
      })
      console.log(3214123, this.dataForm.bookArriveTime, arr);

      // if (arr.length <= 0) {
      //   this.$message({
      //     message: '请选择营业点',
      //     type: 'error'
      //   })
      //   return
      // }
      let data = {
        outletsIds: arr.toString(),
        bookArriveTime: this.dataForm.bookArriveTime.substring(0, 10),
        mealDifferId: this.dataForm.mealDiffer.id,
        statusCode: this.checkList.length > 0 ? this.checkList.toString() : null,
        queryLike: this.changechannelinput ? this.changechannelinput : null,
      }
      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        console.log(res.data.data, );
        res.data.data.forEach((e, i) => {
          if (e.outletsName + e.code == this.ChongFoodNum) {
            // console.log(i);
            this.tableNumCurrent = i

          }
        })


        this.tableNumList = res.data.data

      })
    },
    SalerDialogClick() {
      this.SalerDialog = false
    },
    checkChongFoodCurrent(v, i) {

      this.cantList[i].check = !this.cantList[i].check
      console.log(this.cantList);
      this.tableNumMessage()
    },
    checktableNumCurrent(v, i) {
      if (v.statusCode == 'V') {
        this.tableNumCurrent = i

      }
      // this.ChongFoodNum = v.outletsName + v.code
      // this.dataForm.mealTableId = v.id

    },
    checktableSure() {
      this.dataForm.mealTableId = this.tableNumList[this.tableNumCurrent].id
      this.dataForm.ChongFoodNum = this.tableNumList[this.tableNumCurrent].outletsName + this.tableNumList[this
        .tableNumCurrent].code
      this.ChongFoodNum = this.tableNumList[this.tableNumCurrent].outletsName + this.tableNumList[this
        .tableNumCurrent].code
      this.tableNumdialog = false

    },
    ydOrder() {

      // let {
      //   href
      // } = this.$router.resolve({
      //   path: "/order",
      //   query: {},
      // });
      // window.open(href, "_parent");
      localStorage.setItem('openTaiUser', JSON.stringify(this.dataForm))
      console.log(this.YDID, this.dataForm.outletsId);
      if (!this.orderNum) {
        this.$message({
          message: "请先填写预订信息再点菜",
          type: "error"
        })
        return
      }
      this.$router.push({
        path: "/order",
        query: {
          type: 1,
          outletsId: this.dataForm.outletsId,
          id: this.YDID
        }
      })
    },
    //合计
    getSummaries(param) {
      let sum = ['合计', '', '', '', '', '', '']
      let totalPrice = 0
      let serverPrice = 0
      let tax = 0
      let discount = 0
      let quantity = 0
      this.tableData.forEach(res => {

        serverPrice = serverPrice + res.serverPrice * 1
        tax = tax + res.tax * 1
        discount = discount + res.discount * 1
        totalPrice = totalPrice + res.quantity * res.price
        quantity = quantity + res.quantity * 1
      })
      sum[5] = (serverPrice * 1).toFixed(2)
      sum[4] = (tax * 1).toFixed(2)
      sum[6] = (discount * 1).toFixed(2)
      sum[7] = (quantity * 1)
      sum[8] = (totalPrice * 1 - discount * 1 + tax * 1 + serverPrice * 1).toFixed(2)
      return sum
    },
    getSummarie(param) {
      let sum = ['合计', '', '', '', '', '', '']
      let totalPrice = 0
      this.payList.forEach(res => {
        totalPrice = totalPrice + res.totalPrice
      })
      sum[4] = (totalPrice * 1).toFixed(2)
      return sum
    },
    getInputFocus(event) {
      console.log("event", event)
      event.currentTarget.select();
    },
    //结账收款按钮
    takeMoney() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });



      let url = this.api.orderMenuBill
      let methods = 'post'
      let str = '';
      let type = null
      let flag = false
      let money = 0
      this.paytableData.forEach(v => {
        // console.log(v);
        str += v.productName + ','
        if (v.transactionId) {
          type = v.transactionId
        }

        money += v.totalPrice * 1

        if (v.productCode == '9005' && !v.transactionId) {

          flag = true
        }

      })

      if (money == 0) {

        this.$notify.error({
          title: '请选择结账方式'
        });
        loading.close();

        return


      }
      str = str.slice(0, str.length - 1)

      // if (money != this.dataForm.orderTotalPrice) {
      //   this.$message({
      //     message: "结账金额有误",
      //     type: "error"
      //   })
      //   loading.close();
      //   return
      // }
      if (flag) {
        this.$notify.error({
          title: '微信付款失败'
        });
        loading.close();
        return
      }

      let data = {
        checkType: str,
        orderRecordId: this.dataForm.id,
        orderNum: this.dataForm.orderNum,
        totalPrice: this.dataForm.orderTotalPrice,
        boList: this.paytableData,
      }

      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        // console.log(res);
        loading.close();

        if (res.data.status == 0) {
          // localStorage.removeItem('openTaiUstatus')

          this.payDialog = false
          this.$notify.success({
            title: '结账成功'
          });


          loading.close();
          this.refund()


        } else {
          this.$notify.error({
            title: res.data.message
          });
          loading.close();
        }
      }).catch(() => {
        loading.close();
      })
    },
    //结账付款关闭按钮
    beforeClose() {

      this.payDialog = false

    },
    invoicing() {
      let flagss = false


      let methods = 'get'
      let rounding = 2
      //零头码功能，确定小数点位数
      // rounding; //四舍五入：1.十位  2.个位  3.小数点第一位  4.小数点第二位  5.小数点第三位
      this.$axios({
        url: this.api.zeroCodeByTable + '?mealTableId=' + this.dataForm.mealTableId,
        methods
      }).then(res => {

        if (res.data.status == 1) {
          // console.log(res.data);
          rounding = res.data.data.rounding
        }

      })
      //支付方式图片
      const url = this.api.posProductPayList + '?posBookBill=Y'
      this.loading = true
      this.$axios({
        url,
        methods
      }).then(res => {
        this.loading = false
        this.methodItem = res.data.data
      })
      if (!flagss) {
        this.payDialog = true

      }
      // this.payOrderNum = this.orderObj.orderNum
      // this.payTableNum = this.orderObj.mealTableNum
      this.paytableData = []
    },
    deleteRow(index, rows, row) {
      //行数据
      // console.log(index, row);
      // this.allNum = Number(this.allNum) + Number(row.totalPrice)
      // this.jzmoney = this.allNum

      rows.splice(index, 1);
    },
    // 结账付款 支付方式按钮
    methodClick(v) {

      let num = 0,
        sweepPay, payType
      num = this.jzmoney
      // this.allNum = (this.allNum - this.jzmoney).toFixed(2)
      this.jzmoney = 0


      if (num * 1 == 0) {
        this.$message({
          message: '支付金额不允许为零',
          type: "error"
        })
        return
      }
      // if (v.name == '微信') {
      //   this.lsinput2 = ''
      //   sweepPay = '微信'
      //   payType = 'online'
      //   this.$nextTick(() => {
      //     this.$refs.gain.focus()

      //   }, 100)
      //   setTimeout(() => {
      //     this.lsflag = true
      //   }, 500);
      // }

      this.paytableData.push({
        productId: v.id,
        productCode: v.code_,
        productName: v.name,
        totalPrice: num,

        remark: this.bzinput1,

        billType: 'R',
        transactionId: null,
        pay: false,
        sweepPay,
        payType
      })

      console.log(this.paytableData);
    },
    refund() {
      this.getMoneyList()
    },
    changeRadio(e) {

      this.getMoneyList()
    },
    getMoneyList() {
      let url = this.api.bookBill
      let methods = 'get'
      //参数：
      // orderRecordId：订单id，必传
      // valid：是否有效：Y，没勾选不传
      // payOrRefund：退款：refund，没勾选不传
      // status：结账：SETTLED，没勾选不传
      let data = {
        orderRecordId: this.YDID,
        valid: this.checkList.includes('Y') ? 'Y' : null,
        payOrRefund: this.checkList.includes('refund') ? 'refund' : null,
        status: this.checkList.includes('SETTLED') ? 'SETTLED' : null,
      }


      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        if (!res.data.status) {

          this.payList = res.data.data
          let height = this.$refs.rightBottom.offsetHeight;
          this.moneyHeight = height - 40
          console.log(height, this.moneyHeight);
        }
      })
    },
    openLogDialog() {

      if (Object.keys(this.dataForm).length < 1) {
        return
      }

      this.logDialog = true
      let url = this.api.listPos + '?orderNum=' + this.dataForm.orderNum
      let methods = 'get'
      this.loading = true
      this.$axios({
        url,
        methods

      }).then(res => {
        this.loading = false
        this.discountList = res.data.data

      })



    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    bookRefund() {

      if (!this.multipleSelection.length) {
        this.$message({
          message: "至少选择一条付款",
          type: 'error'
        })
        return
      }

      let isSettled = this.multipleSelection.some(item => {
        return item.status == "SETTLED"
      })
      console.log(isSettled,'isSettled')
      if(isSettled) {
        this.$message({
          message: "选择的数据包含已结账订单，请重新选择",
          type: 'error'
        })
        return
      }

      let id = []
      let total = 0
      let confirmString = ''
      this.multipleSelection.forEach(e => {
        id.push(e.id)
        total += e.totalPrice
        confirmString += e.productName + ' ' + e.totalPrice
      })
      let url = this.api.bookRefund + '?ids=' + id.toString()
      let methods = 'get'
      let data = id

        this.$confirm(`${confirmString} 将做退款处理，是否确定`, '餐单预付款退款', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$axios({
            url,
            methods,

          }).then(res => {
            this.loading = false
            if (!res.data.status) {
              this.$message({
                message: '退款成功',
                type: "success"
              })
              this.getMoneyList()
            }
          }).catch(() => {
            this.loading = false

          })
        }).catch(() => {
          
        });
      
     
      
    },
    print() {
      let url = this.api.printBookBillInfo
      let methods = 'get'
      let data = {
        orderRecordId: this.YDID
      }
      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        console.log(res);
        if (!res.data.status) {
          // this.$message({
          //   message: '正在向打印机推送打印任务',
          //   type: "success"
          // })
          this.getCurPosSite()
          this.printName = localStorage.getItem('printName')

          this.PDate = this.GetPrinter()

          this.printFlag = true
          let price = 0
          this.printobj = res.data.data
          if (res.data.data.bills.length) {
            res.data.data.bills.forEach(e => {
              price = price + e.totalPrice * 1
            })
          }
          this.printobj.billprice = price.toFixed(2)
        }


      })
    },
    //判断账单打印机 是否为本机内置
    getCurPosSite() {
      let url = this.api.getCurPosSite
      let methods = 'get'
      this.$axios({
        url,
        methods
      }).then(res => {
        // console.log(res.data);
        if (res.data.status == 0) {
          this.checkPrinter = res.data.data.checkPrinter
          console.log('是否为本机内置', this.checkPrinter);
        }
      })

    },
    //获取当前电脑得打印机
    GetPrinter() {
      //获取当前打印机

      LODOP = getLodop();

      var iCount = LODOP.GET_PRINTER_COUNT();

      var PData = [];

      for (var i = 0; i < iCount; i++) {
        PData.push({
          code: i,
          name: LODOP.GET_PRINTER_NAME(i)
        });
      }

      return PData;
    },
    closeprintFlag() {
      this.printFlag = false
    },
    printtable() {
      const loading = this.$loading({
        lock: true,
        text: '打印中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 500);

      if (this.checkPrinter == 2) {
        this.ipadprint()
        this.$message({
          message: "已成功向总控打印机推送任务",
          type: "success"
        })
      } else {
        // 本机打印
        if (!localStorage.getItem('printName')) {
          this.PDate = this.GetPrinter()
          this.$message({
            message: '请先选择打印机再打印',
            type: 'warning'
          });
        } else {

          // console.log('打印');
          this.$bus.$emit('printName', this.printName)
          this.$refs.billa.getlist()
          this.$message({
            message: "已成功向本地打印机推送任务",
            type: "success"
          })
          this.printFlag = false

          // localStorage.removeItem('openTaiUstatus')
          if (this.routeStatus == 0) {
            this.refund()
          }
        }
      }
    },
    changePDate(v) {
      console.log('选择打印机', this.printName, v);
      localStorage.setItem('printName', v)
      this.printName = v
      // this.$refs.bill.getPrint()
    },
    //查询酒店打印主控点的设备编码
    printPosCodes() {
      let code = localStorage.getItem('hotelCode')
      let url = this.api.printPosCode + '?hotelCode=' + code
      let methods = 'get'

      this.$axios({
        url,
        methods
      }).then(res => {
        this.printPosCode = res.data.data.printPosCode
      })
    },
    ipadprint() {
      let url = this.api.orderMq
      let methods = 'post'
      let obj = {
        data: JSON.stringify(this.printobj),
      }

      let data = {
        toipcName: this.printPosCode,
        status: 'Unprinted',
        hotelCode: localStorage.getItem('hotelCode'),

        type: 'bill',
        value: JSON.stringify(obj),
      }
      this.$axios({
        url,
        methods,
        data
      }).then(res => {
        // console.log(res);
      })
    },
    bookUpdate(val) {
      console.log(val);
      this.discountModelList.forEach(res => {
        if (res.id == val) {
          this.dataForm.discountModelName = res.name

        }
      })
      console.log(val);
      if (!this.YDID) {
        return
      }

      let data = {
        discountModelId: this.dataForm.discountModelId,
        orderRecordId: this.YDID
      }
      let url = this.api.bookUpdateDiscount
      let methods = 'get'
      this.$axios({
        url,
        methods,
        data
      }).then(res => {

        this.getData(this.$route.query)

      })
    }
  }
  }
</script>

<style lang="scss" scoped>
  .addreserve {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .header {
      width: 100%;
      height: 66px;
      background: #ffffff;
      // border-radius: 20px;
      border: 1px solid #eaeaea;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      position: relative;
      color: #666666;

      .reservesign {
        position: absolute;
        top: 0px;
        margin-left: 20px;
      }

      .FunctionalityBtn {
        display: flex;

        .feffBtn {
          width: 80px;
          height: 40px;
          background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
          box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
          border-radius: 38px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          margin: 0 5px;
        }

        .blueBtn {
          width: 80px;
          height: 40px;
          background: #0099ff;
          box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
          margin: 0 5px;
          border-radius: 30px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          line-height: 1;
        }
      }
    }

    .content {
      width: 100%;
      display: flex;
      justify-content: space-around;

      .leftMain {
        width: 55%;
        border-right: 1px solid #eee;
        min-height: calc(100vh - 152px);
        max-height: calc(100vh - 152px);
        height: 100%;
        // border-radius: 20px;
        // margin-top: 10px;
        background: #fff;
        padding: 0px 0px 0px 10px;
        overflow: auto;
        position: relative;

        .titleName {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #0099ff;
          margin-bottom: 10px;
          padding: 00px 20px;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          height: 40px;
          line-height: 40px;
        }

        .dataForm {
          padding-right: 10px;
        }

        .mainTOP {
          height: 360px;
        }







        .rodege45 {
          position: fixed;
          left: 45%;
          bottom: 120px;
          z-index: 1000;
          transform: rotate(-25deg);
        }
      }

      .rightMain {

        width: 45%;
        min-height: calc(100vh - 152px);
        height: 100%;
        // border-radius: 20px;
        // margin-top: 10px;

        display: flex;
        flex-direction: column;

        .rightTop {
          background: #fff;
          // border-radius: 20px;
          height: 360px;
          // margin-bottom: 10px;
          overflow: auto;

          .selectmenu {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;

            .selectTitle {
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #0099ff;
              font-size: 16px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 10px 0 20px;
              border-top: 1px solid #eee;
              border-bottom: 1px solid #eee;

              .feffBtn {
                width: 120px;
                height: 30px;
                background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
                box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
                border-radius: 38px;
                text-align: center;
                font-size: 16px;

                cursor: pointer;
                color: #fff;
                line-height: 30px;
                margin: 0 5px;
              }
            }

            .selectMain {
              border-bottom: 1px solid #eaeaea;
              // height: 630px;
              flex: 1;
              width: 100%;
              overflow: auto;

              .selectItem {
                width: 100%;
                border-bottom: 1px solid #eaeaea;
                cursor: pointer;

                .selectTop {
                  display: flex;
                  padding: 10px 9px 0;

                  .selectTopLeft {
                    flex: 1;
                    display: flex;
                    align-items: center;
                  }

                  .selectNum {
                    flex: 0 0 120px;
                    display: flex;
                    align-items: center;
                    margin-right: 9px;
                  }
                }

                .selectBottom {
                  display: flex;
                  align-items: center;
                  padding: 0 9px;
                  color: #666;
                  justify-content: space-between;
                  margin-top: 5px;

                  .selectLeftBottom {
                    display: flex;
                    align-items: center;
                    color: #666;
                  }

                  /deep/ .el-input__suffix {
                    top: -3px !important;
                  }
                }

                .funcBtn {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 10px 20px;

                  .funcBtnItem {
                    min-width: 41px;
                    border-radius: 30px;
                    color: #fff;
                    font-size: 20px;
                    padding: 7px 10px;
                    background: #0099ff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }

                  .funcBtnItem:nth-child(2) {
                    margin-right: 200px;
                  }
                }
              }
            }

            .selectFooter {
              flex: 0 0 243px;
              display: flex;
              flex-direction: column;

              .footerTop {
                display: flex;
                border-bottom: 1px solid #eaeaea;

                .bz {
                  flex: 1;
                }

                .beizhu {
                  margin: 0 10px;
                  background: #eeeeee;
                  color: #666666;
                  height: 56px;
                  line-height: 56px;
                  // text-indent: 10px;
                  // border-radius: 6px;
                }

                .allPrice {
                  flex: 0 0 215px;
                  padding: 20px 7px;
                  border-left: 1px solid #eaeaea;

                  .totalPrice {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    font-size: 36px;
                    color: #fe8d30;
                  }
                }
              }

              .footerBottom {
                flex: 0 0 79px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px;

                .blueBtn {
                  width: 140px;
                  height: 60px;
                  background: #0099ff;
                  color: #fff;
                  font-size: 24px;
                  text-align: center;
                  border-radius: 38px;
                  margin-right: 10px;
                  cursor: pointer;
                }

                .jbBtn {
                  width: 140px;
                  cursor: pointer;
                  height: 60px;
                  background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
                  box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
                  border-radius: 38px;
                  color: #fff;
                  font-size: 24px;
                  line-height: 60px;
                  text-align: center;
                }

                .cvAndSD {
                  display: flex;
                }
              }
            }
          }
        }

        /deep/.el-input__inner {
          border: none;
          width: 70px !important;
          padding: 0;
          // line-height: 0 !important;
          background: transparent;
        }

        .rightBottom {
          background: #fff;
          // border-radius: 20px;
          // height: 45%;
          height: calc(100% - 360px);

          .selectTitle {
            width: 100%;
            height: 40px;
            line-height: 1;
            text-align: center;
            color: #0099ff;
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px 0 20px;
            border-top: 1px solid #eee;
            border-bottom: 1px solid #eee;

            .rightSSSS {
              display: flex;
            }

            .blueBtn {
              width: 80px;
              height: 30px;
              background: #0099ff;
              box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
              margin: 0 5px;
              border-radius: 30px;
              text-align: center;
              cursor: pointer;
              color: #fff;
              line-height: 0px;
            }
          }

          .totalPrice {
            display: flex;
            color: #666;
            height: 30px;
            align-items: center;

            div:nth-child(1) {
              margin: 0 30px 0 10px;
            }
          }
        }
      }
    }

    .dialogClass {
      /deep/.el-input__inner {
        font-size: 14px;
        border: none;
        width: 100% !important;
        background: #eee;
      }

      /deep/.el-button--primary {
        border-radius: 38px;
        width: 200px;
        background: -webkit-gradient(linear,
            0 0,
            0 100%,
            from(#ffbe34),
            to(#fe812f)) !important;
        border: none;
      }

      /deep/.el-button {
        font-size: 28px;
        height: 60px;
        font-weight: 400;
      }

      /deep/.el-dialog__footer {
        margin-bottom: 30px;
      }

      /deep/.el-dialog {
        // height: 612px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 10px;
      }

      /deep/.el-dialog__header {
        margin-top: 50px;
        background: #fff;
      }

      /deep/.el-dialog__title {
        color: #0099ff;
        font-size: 28px;
      }

      /deep/.el-input__inner {
        width: 340px;
        height: 36px;
        line-height: 36px;
      }

      /deep/.el-input--suffix {
        // margin-bottom: 20px;
      }

      /deep/.el-dialog__body {
        // height: 412px;
        overflow: hidden;
      }

      .changeReason {
        padding: 0 20px;

        .returnTitle {
          margin: 20px 0 10px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }

        .returnItem {
          display: flex;
          flex-wrap: wrap;
          height: 200px;

          div {
            margin: 5px 20px 5px 0;
            font-size: 24px;
            width: 190px;
            height: 66px;
            background: #eeeeee;
            border-radius: 6px;
            line-height: 66px;
            text-align: center;
            cursor: pointer;
          }
        }
      }

      .returnItemCurrent {
        background: #0099ff !important;
        color: #fff;
      }
    }
  }



  .addFoodTTT {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .addFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 36px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;

    /deep/.el-input__inner {
      font-size: 18px;
      border: none;
      width: 200px !important;
      padding: 0;
      background: #eee;
      text-align: center;
    }
  }

  .paytableunder {
    display: flex;
    justify-content: center;

    .underLeft {
      display: flex;
      flex-direction: column;
    }

    /deep/.el-input__inner {
      width: 100% !important;
    }

    .underMiddle {
      width: 247px;
      height: 140px;
      background: #eeeeee;
      border-radius: 6px;
      padding: 20px;
      margin: 16px 0 0 10px;

      div:nth-child(1) {
        margin-bottom: 20px;
        font-size: 18px;
      }

      div:nth-child(2) {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0099ff;
      }
    }

    .Collection {
      width: 160px;
      height: 140px;
      background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
      box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
      border-radius: 6px;
      color: #fff;
      text-align: center;
      line-height: 140px;
      font-size: 18px;
      cursor: pointer;
      margin: 16px 0 0 10px;
    }
  }

  .payMethods {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 25px;

    .methodItem {
      width: 160px;
      height: 100px;
      background: #eeeeee;
      border-radius: 6px;
      font-size: 18px;
      color: #666;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 10px 10px 0 0;
      cursor: pointer;
    }

    .methodItem:nth-child(5n + 5) {
      margin: 10px 0 0 0;
    }

    .methodItem:nth-child(1) {
      margin: 10px 10px 0 10px;
    }

    .methodItem:nth-child(6) {
      margin: 10px 10px 0 10px;
    }

    .methodItem:nth-child(11) {
      margin: 10px 10px 0 10px;
    }
  }

  .discountflag {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    div {
      margin: 5px 20px 5px 0;
      font-size: 18px;
      width: 190px;
      height: 66px;
      background: #eeeeee;
      border-radius: 6px;
      line-height: 66px;
      text-align: center;
      cursor: pointer;
    }
  }

  .allPrices {
    margin-left: 5px;
    color: #c0392b;
    font-size: 16px;
  }

  .changeselect {
    padding: 0 20px;
    overflow-y: auto;
    height: 500px;

    .returnItem {
      display: flex;
      flex-wrap: wrap;
      // height:100px;

      div {
        margin: 5px 20px 15px 0;
        padding: 5px 10px;
        font-size: 24px;
        // width: 190px;
        // height: 66px;
        // background: #eeeeee;
        border-radius: 6px;
        // line-height: 66px;
        text-align: center;
        cursor: pointer;
      }
    }

    .returnItemCurrent {
      // background: #0099ff !important;

      color: #0099ff;
    }

    .Item {
      display: flex;
      flex-wrap: wrap;

      .Items {
        margin: 5px 20px 5px 0;
        font-size: 14px;
        width: 150px;
        height: 80px;
        background: #eeeeee;
        border-radius: 6px;
        line-height: 80px;
        text-align: center;
        cursor: pointer;

        div {
          height: 20px;
        }
      }

      .ItemCurrent {
        background: #0099ff !important;
        color: #fff;
        margin: 5px 20px 5px 0;
        font-size: 14px;
        width: 150px;
        height: 80px;
        border-radius: 6px;
        line-height: 80px;
        text-align: center;
        cursor: pointer;

        div {
          height: 20px;
        }
      }
    }


  }
</style>

<style lang="scss" scoped>
  /deep/.el-dialog__body {
    padding: 0 25px 25px !important;
    width: 100%;
  }

  /deep/.el-dialog__footer {
    width: 100%;
  }

  /deep/.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }

  /deep/.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }

  /deep/ .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .el-col {
    margin-bottom: 6px;
  }

  .printSelect {
    display: flex;
    align-items: center;
    justify-content: center;

    .PDateName {
      border: 1px solid #666;
      width: 200px;
      height: 30px;
      margin-left: 20px;

      /deep/.el-input__inner {
        // border: none;
        width: 200px !important;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        // line-height: 0 !important;
        background: transparent;
      }

      /deep/ .el-input--suffix {
        margin-bottom: 0;
      }
    }
  }
</style>